import React, { useEffect, useState } from 'react';
import { TOAST_STYLES } from 'constants/styles';

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        if (message) {
            // Trigger entrance animation
            setTimeout(() => setIsVisible(true), 10);

            // Auto-dismiss after duration
            const dismissTimer = setTimeout(() => {
                setIsExiting(true);
                setTimeout(() => {
                    setIsVisible(false);
                    if (onClose) onClose();
                }, 300); // Wait for exit animation
            }, duration);

            return () => clearTimeout(dismissTimer);
        }
    }, [message, duration, onClose]);

    if (!message) return null;

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            setIsVisible(false);
            if (onClose) onClose();
        }, 300);
    };

    const styles = {
        ...TOAST_STYLES.container,
        ...(type === 'error' ? TOAST_STYLES.error : TOAST_STYLES.success),
        opacity: isVisible && !isExiting ? 1 : 0,
        transform: isVisible && !isExiting 
            ? 'translateX(-50%) translateY(0)' 
            : 'translateX(-50%) translateY(-20px)',
    };

    return (
        <div style={styles}>
            <div style={TOAST_STYLES.content}>
                <span style={TOAST_STYLES.icon}>
                    {type === 'error' ? '❌' : '✅'}
                </span>
                <span style={TOAST_STYLES.message}>{message}</span>
                <button 
                    onClick={handleClose}
                    style={{
                        marginLeft: 'auto',
                        background: 'none',
                        border: 'none',
                        fontSize: '18px',
                        cursor: 'pointer',
                        opacity: 0.7,
                        padding: '0 4px',
                        pointerEvents: 'auto'
                    }}
                    aria-label="Close"
                >
                    ×
                </button>
            </div>
        </div>
    );
};

export default Toast;